import { createAction, props } from '@ngrx/store';

import { Quote } from '@lockton-apps/shared/interfaces';

export enum DashboardContactActionTypes {
  Init = '[DashboardContact Page] Initialise Contact Dashboard',
  ViewQuoteClicked = '[DashboardContact Page] View Quote Clicked',
  PoliciesFilterChanged = '[DashboardContact Page] Policies Filter Changed',
  DocumentsFilterChanged = '[DashboardContact Page] Documents Filter Changed',
  ViewMoreDocuments = '[DashboardContact Page] View More Documents',
  FolderSelected = '[DashboardContact Page] Folder Selected',
  UploadDocumentsClicked = '[DashboardContact Page] Upload Documents Clicked',
  FilesDropped = '[DashboardContact Page] Files Dropped',
  DocumentsViewTypeChanged = '[DashboardContact Page] Documents View Type Changed',
  DocumentsClientSelected = '[DashboardContact Page] Documents Client Selected',
  DocumentSelected = '[DashboardContact Page] Document Selected',
  DocumentDeleted = '[DashboardContact Page] Document Deleted',
  Destroyed = '[DashboardContact Page] Destroyed',
}

export const DashboardContactActions = {
  init: createAction(DashboardContactActionTypes.Init),
  viewQuoteClicked: createAction(
    DashboardContactActionTypes.ViewQuoteClicked,
    props<{ quote: Quote }>()
  ),
  uploadDocumentsClicked: createAction(
    DashboardContactActionTypes.UploadDocumentsClicked,
    props<{ files?: File[] }>()
  ),
  filesDropped: createAction(
    DashboardContactActionTypes.FilesDropped,
    props<{ files: File[] }>()
  ),
  documentsViewTypeChanged: createAction(
    DashboardContactActionTypes.DocumentsViewTypeChanged,
    props<{ viewType: string }>()
  ),
  folderSelected: createAction(
    DashboardContactActionTypes.FolderSelected,
    props<{ folderId: number | null }>()
  ),
  documentSelected: createAction(
    DashboardContactActionTypes.DocumentSelected,
    props<{ id: number; name: string }>()
  ),
  documentDeleted: createAction(
    DashboardContactActionTypes.DocumentDeleted,
    props<{ id: number; name: string }>()
  ),
  policiesFilterChanged: createAction(
    DashboardContactActionTypes.PoliciesFilterChanged,
    props<{ filter: Record<string, any> }>()
  ),
  documentsFilterChanged: createAction(
    DashboardContactActionTypes.DocumentsFilterChanged,
    props<{ filter: Record<string, any> }>()
  ),
  viewMoreDocuments: createAction(
    DashboardContactActionTypes.ViewMoreDocuments
  ),
  documentsClientSelected: createAction(
    DashboardContactActionTypes.DocumentsClientSelected,
    props<{ clientId: number }>()
  ),
  destroyed: createAction(DashboardContactActionTypes.Destroyed),
};
